export const PERIODS = Object.freeze({
  QUARTER1: 'quarter1',
  QUARTER2: 'quarter2',
  QUARTER3: 'quarter3',
  QUARTER4: 'quarter4',
  YEAR: 'year',
  JANUARY: 'january',
  FEBRUARY: 'february',
  MARCH: 'march',
  APRIL: 'april',
  MAY: 'may',
  JUNE: 'june',
  JULY: 'july',
  AUGUST: 'august',
  SEPTEMBER: 'september',
  OCTOBER: 'october',
  NOVEMBER: 'november',
  DECEMBER: 'december',
})
